import { rest } from "msw";

export const handlers = [
    rest.get(
        `${process.env.REACT_APP_ONLINE_API_BASE_URL}/login/:sessionCode`,
        (req, res, ctx) => {
            return res(
                ctx.status(200),
                ctx.json({
                    token: "ezferfrerfefrfeafe",
                })
            );
        }
    ),

    rest.get(
        `${process.env.REACT_APP_ONLINE_API_BASE_URL}/api/check-code/:sessionCode`,
        (req, res, ctx) => {
            if (
                "DEVVVV" === req.params.sessionCode ||
                "DEVIL" === req.params.sessionCode
            ) {
                return res(ctx.status(200));
            } else {
                return res(ctx.status(404));
            }
        }
    ),

    //  Mock Pin
    rest.post(
        `${process.env.REACT_APP_ONLINE_API_BASE_URL}/form/scenario/reference_multi_devices`,
        async (req, res, ctx) => {
            const body = await req.json();
            if ("1" === body.idReference) {
                return res(
                    ctx.status(200),
                    ctx.json({
                        token: "ezferfrerfefrfeafe",
                    })
                );
            }
        }
    ),

    //  Mock Nom prenom
    rest.post(
        `${process.env.REACT_APP_ONLINE_API_BASE_URL}/form/scenario/nom_prenom`,
        async (req, res, ctx) => {
            //const body = await req.json();
            return res(
                ctx.status(200),
                ctx.json({
                    token: "ezferfrerfefrfeafe",
                })
            );
        }
    ),

    //Get public information on session
    rest.get(
        `${process.env.REACT_APP_ONLINE_API_BASE_URL}/api/session/:sessionCode/connection-information`,
        (req, res, ctx) => {
            if ("DEVVVV" === req.params.sessionCode) {
                return res(
                    ctx.status(200),
                    ctx.json({
                        codeOnline: "DEVVVV",
                        scenario: "reference_multi_devices",
                        sessionName: "sessionName",
                    })
                );
            } else {
                return res(ctx.status(404));
            }
        }
    ),

    rest.get(
        `${process.env.REACT_APP_ONLINE_API_BASE_URL}/api/session/reverse-subdomain`,
        (req, res, ctx) => {
            return res(
                ctx.status(200),
                ctx.json({
                    codeOnline: "DEVVVV",
                    subdomain: "sonyy",
                })
            );
        }
    ),

    rest.get(
        `${process.env.REACT_APP_ONLINE_API_BASE_URL}/api/session/:sessionCode/subdomain`,
        (req, res, ctx) => {
            return res(
                ctx.status(200),
                ctx.json({
                    codeOnline: "DEVVVV",
                    subdomain: "sonyy",
                })
            );
        }
    ),

    rest.get(
        `${process.env.REACT_APP_ONLINE_API_BASE_URL}/api/session/customization`,
        (req, res, ctx) => {
            return res(
                ctx.status(200),
                ctx.json({
                    subdomain: "",
                    customization: {
                        logoAlignment: "left",
                        titleColor: "blue",
                        titleBackgroundColor: "#7f5af0",
                        buttonColor: "#fffffe",
                        buttonBackgroundColor: "#7f5af0",
                        logoUrl: "",
                    },
                })
            );
        }
    ),

    //Get complete information on session, need to be authenticated
    rest.get(
        `${process.env.REACT_APP_ONLINE_API_BASE_URL}/api/session/:sessionCode`,
        // - 200: Session information (JSON)
        // - 401: Missing connection information
        // - 403: Not authorized to access requested session information
        (req, res, ctx) => {
            return res(
                ctx.status(200),
                ctx.json({
                    codeOnline: "DEVVVV",
                    scenario: "reference_multi_devices",
                    sessionName: "sessionName",
                    lang: "FR",
                    streaming: "zoom",
                    streamingLibelle: "zoom",
                    streamingLogin: "8130830513",
                    streamingPassword: "test",
                    streamingSignature:
                        "pas_possible_de_gen_une_signature_avec_expiration_indefinie_donc_je_met_ca",
                })
            );
        }
    ),

    rest.get(
        `${process.env.REACT_APP_ONLINE_API_BASE_URL}/api/user/me?additionalFields=proxies`,
        (req, res, ctx) => {
            return res(
                ctx.status(200),
                ctx.json({
                    quizzboxUuid: "fref612515erreg",
                    onlineCode: "DEVVVV",
                    email: null,
                    displayName: "MohamedJeTeVois",
                    firstName: null,
                    weight: 2,
                    remoteNumber: 5099,
                    numTelecoEncrypted: "ZsyuykfIX8BqZ6uXMuFgHQ==",
                    proxies: [
                        {
                            quizzboxUuid: "fref612515errep",
                            onlineCode: "DEVOTZ",
                            email: null,
                            displayName: "Proxy1",
                            firstName: null,
                            weight: 2,
                            remoteNumber: 5098,
                            numTelecoEncrypted: "ZsyderzIX8BqZ6uXMuFgHQ==",
                        },
                    ],
                })
            );
        }
    ),

    rest.get(
        `${process.env.REACT_APP_ONLINE_API_BASE_URL}/api/user/me?additionalFields=proxies,signature`,
        (req, res, ctx) => {
            return res(
                ctx.status(200),
                ctx.json({
                    quizzboxUuid: "fref612515erreg",
                    onlineCode: "DEVVVV",
                    email: null,
                    displayName: "MohamedJeTeVois",
                    firstName: null,
                    weight: 2,
                    remoteNumber: 5099,
                    numTelecoEncrypted: "ZsyuykfIX8BqZ6uXMuFgHQ==",
                    signature: null,
                    proxies: [
                        {
                            quizzboxUuid: "fref612515errep",
                            onlineCode: "DEVOTZ",
                            email: null,
                            displayName: "Proxy1",
                            firstName: null,
                            weight: 2,
                            remoteNumber: 5098,
                            numTelecoEncrypted: "ZsyderzIX8BqZ6uXMuFgHQ==",
                        },
                    ],
                })
            );
        }
    ),

    rest.put(
        `${process.env.REACT_APP_ONLINE_API_BASE_URL}/api/user/me/sign`,
        (req, res, ctx) => {
            return res(
                ctx.status(200),
                ctx.json({
                    quizzboxUuid: "fref612515erreg",
                    onlineCode: "DEVVVV",
                    email: null,
                    displayName: "MohamedJeTeVois",
                    firstName: null,
                    weight: 2,
                    remoteNumber: 5099,
                    numTelecoEncrypted: "ZsyuykfIX8BqZ6uXMuFgHQ==",
                    signature:
                        "data:image/png;base64,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",
                    proxies: [
                        {
                            quizzboxUuid: "fref612515errep",
                            onlineCode: "DEVOTZ",
                            email: null,
                            displayName: "Proxy1",
                            firstName: null,
                            weight: 2,
                            remoteNumber: 5098,
                            numTelecoEncrypted: "ZsyderzIX8BqZ6uXMuFgHQ==",
                        },
                    ],
                })
            );
        }
    ),

    //  Mock EmailPassword
    rest.post(
        `${process.env.REACT_APP_ONLINE_API_BASE_URL}/api/request-password/:sessionCode`,
        (req, res, ctx) => {
            if ("so@so" === req.params.email) {
                return res(ctx.status(200));
            } else if ("DEVIL" === req.params.sessionCode) {
                return res(ctx.status(403));
            } else {
                return res(ctx.status(404));
            }
        }
    ),

    rest.post(
        `${process.env.REACT_APP_ONLINE_API_BASE_URL}/form/scenario/email_password`,
        (req, res, ctx) => {
            if ("good" === req.params.password) {
                return res(ctx.status(200));
            } else if ("error" === req.params.password) {
                return res(ctx.status(401));
            } else {
                return res(ctx.status(404));
            }
        }
    ),

    //Mock EmailPasswordSMS

    //Send To Code verification SMS
    rest.post(
        `${process.env.REACT_APP_ONLINE_API_BASE_URL}/api/request-verification-code/:sessionCode`,
        (req, res, ctx) => {
            if (
                "so@so" === req.params.email &&
                "good" === req.params.password
            ) {
                return res(
                    ctx.status(200),
                    ctx.json({
                        phoneNumber: "*******8783",
                    })
                );
            } else if (
                "so@so" === req.params.email &&
                "error" === req.params.password
            ) {
                return res(ctx.status(401));
            } else {
                return res(ctx.status(404));
            }
        }
    ),

    //Code verification SMS
    rest.post(
        `${process.env.REACT_APP_ONLINE_API_BASE_URL}/form/scenario/email_password_sms`,
        (req, res, ctx) => {
            if ("good" === req.params.verificationCode) {
                return res(ctx.status(204));
            } else if ("error" === req.params.verificationCode) {
                return res(ctx.status(401));
            } else {
                return res(ctx.status(404));
            }
        }
    ),
];
